/**
 * Custom styles for react-select component
 * Supports both light and dark themes
 */

export const getSelectStyles = (activeColorStyle, isLightTheme = false) => ({
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled
      ? (isLightTheme ? 'rgba(29, 37, 59, 0.05)' : 'rgba(255, 255, 255, 0.05)')
      : 'transparent',
    borderColor: state.isDisabled
      ? (isLightTheme ? 'rgba(29, 37, 59, 0.2)' : 'rgba(255, 255, 255, 0.2)')
      : state.isFocused
        ? activeColorStyle.borderColor
        : isLightTheme
          ? 'rgba(29, 37, 59, 0.5)'
          : '#2b3553',
    borderRadius: 0,
    minHeight: '38px',
    boxShadow: state.isDisabled
      ? 'none'
      : state.isFocused ? `0 0 0 1px ${activeColorStyle.borderColor}` : 'none',
    opacity: state.isDisabled ? 0.6 : 1,
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    '&:hover': {
      borderColor: state.isDisabled
        ? (isLightTheme ? 'rgba(29, 37, 59, 0.2)' : 'rgba(255, 255, 255, 0.2)')
        : state.isFocused
          ? activeColorStyle.borderColor
          : isLightTheme
            ? 'rgba(29, 37, 59, 0.5)'
            : '#2b3553',
    },
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: isLightTheme ? '#ffffff' : '#27293d',
    borderRadius: 0,
    border: isLightTheme
      ? '1px solid rgba(29, 37, 59, 0.1)'
      : '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  spectator: (provided) => ({
    ...provided,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? isLightTheme
        ? 'rgba(29, 37, 59, 0.05)'
        : 'rgba(255, 255, 255, 0.05)'
      : state.isSelected
        ? isLightTheme
          ? 'rgba(29, 37, 59, 0.1)'
          : 'rgba(255, 255, 255, 0.1)'
        : 'transparent',
    color: state.isSelected
      ? activeColorStyle.borderColor
      : isLightTheme
        ? '#1d253b'
        : '#ffffff',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: isLightTheme
        ? 'rgba(29, 37, 59, 0.1)'
        : 'rgba(255, 255, 255, 0.1)',
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: isLightTheme
      ? 'rgba(29, 37, 59, 0.05)'
      : 'rgba(255, 255, 255, 0.1)',
    border: isLightTheme
      ? '1px solid rgba(29, 37, 59, 0.4)'
      : '1px solid rgba(255, 255, 255, 0.6)',
    borderRadius: 0,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: isLightTheme ? '#1d253b' : '#ffffff',
    fontSize: '0.875rem',
    fontWeight: 500,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: isLightTheme ? '#1d253b' : '#ffffff',
    borderLeft: isLightTheme
      ? '1px solid rgba(29, 37, 59, 0.4)'
      : '1px solid rgba(255, 255, 255, 0.6)',
    '&:hover': {
      backgroundColor: isLightTheme ? 'rgba(29, 37, 59, 0.2)' : 'rgba(255, 255, 255, 0.2)',
      color: isLightTheme ? '#1d253b' : '#ffffff',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: isLightTheme
      ? 'rgba(29, 37, 59, 1)'
      : 'rgba(255, 255, 255, 0.4)',
    fontSize: '12px',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    fontSize: '12px',
    color: state.isDisabled
      ? (isLightTheme ? 'rgba(29, 37, 59, 0.4)' : 'rgba(255, 255, 255, 0.4)')
      : (isLightTheme ? '#1d253b' : '#ffffff'),
  }),
  input: (provided) => ({
    ...provided,
    color: isLightTheme ? '#1d253b' : '#ffffff',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isDisabled
      ? (isLightTheme ? 'rgba(29, 37, 59, 0.2)' : 'rgba(255, 255, 255, 0.2)')
      : (isLightTheme
        ? 'rgba(29, 37, 59, 0.4)'
        : 'rgba(255, 255, 255, 0.4)'),
    '&:hover': {
      color: state.isDisabled
        ? (isLightTheme ? 'rgba(29, 37, 59, 0.2)' : 'rgba(255, 255, 255, 0.2)')
        : (isLightTheme
          ? 'rgba(29, 37, 59, 0.6)'
          : 'rgba(255, 255, 255, 0.6)'),
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: isLightTheme
      ? 'rgba(29, 37, 59, 0.4)'
      : 'rgba(255, 255, 255, 0.4)',
    paddingRight: '0',
    '&:hover': {
      color: isLightTheme
        ? 'rgba(29, 37, 59, 0.6)'
        : 'rgba(255, 255, 255, 0.6)',
    },
  }),
});

